"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generatePageKey = void 0;
exports.isInstanceOf = isInstanceOf;
/**
 * Common hash key generator function for pagination pages
 * This creates a consistent key from pagination parameters to identify pages in the store
 *
 * @param params Object containing pagination parameters
 * @returns A string key for the page
 */
var generatePageKey = function (params) {
    if (params === void 0) { params = {}; }
    var _a = params || {}, _b = _a.page, page = _b === void 0 ? 1 : _b, _c = _a.limit, limit = _c === void 0 ? 10 : _c, _d = _a.search, search = _d === void 0 ? '' : _d, 
    // Add other common parameters here
    otherParams = __rest(_a, ["page", "limit", "search"]);
    // Create a base key from the common parameters
    var key = "p".concat(page, "_l").concat(limit);
    // Add search parameter if not empty
    if (search) {
        key += "_q".concat(search);
    }
    // Add any other parameters that might be specific to certain models
    var extraParams = Object.entries(otherParams)
        .filter(function (_a) {
        var _ = _a[0], value = _a[1];
        return value !== undefined && value !== null && value !== '';
    })
        .map(function (_a) {
        var key = _a[0], value = _a[1];
        return "".concat(key).concat(value);
    })
        .join('_');
    if (extraParams) {
        key += "_".concat(extraParams);
    }
    return key;
};
exports.generatePageKey = generatePageKey;
/**
 * Type guard to check if an object is of a specific model class
 *
 * @param value The value to check
 * @param className The name of the class to check against
 * @returns True if the value is an instance of the specified class
 */
function isInstanceOf(value, className) {
    return value &&
        typeof value === 'object' &&
        value.constructor &&
        value.constructor.name === className;
}
